module.exports = __webpack_public_path__ + "static/media/vegitables_18.d2426bc8.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_18.csv
// module id = 600
// module chunks = 0